export class GenericPlace {
  public static readonly LONGITUDE: string = 'placeLNG';
  public static readonly LATITUDE: string = 'placeLAT';
  public static readonly PLACE_ID: string = 'place';
  public static readonly NAME: string = 'placeName';

  public latitude: number;
  public longitude: number;
  public shortName: string;
  public placeId: string;

  constructor() {
    this.latitude = 0;
    this.longitude = 0;
    this.shortName = '';
    this.placeId = '';
  }
}
